module.exports = __webpack_public_path__ + "media/images/menu/btn-menu-mobile-6ec1223ca49b241671151e484fe358cc.png";